import React from 'react';
import { Button } from 'ui';
import { getSubscriptionAmount, getSubscriptionInterval } from '../../../utils/subscriptionUtils';

// Base Component
const BillingModalMainWrapper = ({ subscription = {}, children, buttonText, onButtonClick, postDiv }) => {
  const quantity = subscription?.quantity || 0;
  const memberString = quantity === 1 ? `${quantity} member` : `${quantity} members`;
  const formattedAmount = getSubscriptionAmount(subscription);
  const interval = getSubscriptionInterval(subscription);

  return (
    <div>
      <h4>Subscription and Billing</h4>
      <div style={{ maxWidth: '329px' }}>
        <p>
          Your subscription is ${formattedAmount}/{interval} per team member and you have {memberString}.
        </p>
        {children}
      </div>
      <div style={{ margin: '20px 20px 29px 0px' }}>
        <Button variant="white" onClick={onButtonClick}>
          {buttonText}
        </Button>
      </div>
      {postDiv}
    </div>
  );
};

export default BillingModalMainWrapper;